export default {
  name: 'marking--cisPackageType',
};